import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { FormGroup, FormControl, Validators } from '@angular/forms';
import swal from 'sweetalert2';
import { ServicioService } from "../../services/servicio.services";
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { auth } from 'app/models/ejemplo.model';
import { RecaptchaModule } from 'ng-recaptcha';
import { RecaptchaFormsModule } from 'ng-recaptcha/forms';
interface FormModel {
  captcha?: string;
}

@Component({
  selector: 'login',
  templateUrl: 'login.template.html',
  styleUrls: ['./login.template.css']
})
export class LoginComponent implements OnInit {
  public cargando:any = false;

  constructor(private _servicios: ServicioService, 
              private _router: Router){
  }
  token: any;
  usuariodb: any;
  usuario:string="";
  cliente:string="";
  password:string = "";
  flag: any;
  email: any;
  loginForm = new FormGroup({
    fusuario: new FormControl("",Validators.required),
    fpassword: new FormControl("",Validators.required),
    captcha: new FormControl("",Validators.required),
    fcliente: new FormControl("",Validators.required)
  });

  ngOnInit(){
    if(sessionStorage.getItem('UsuarioLog') != null){
      this._router.navigateByUrl("starterview");
    }
    this.usuario = "";
    this.password = "";
    this.cliente="";
    this.loginForm.patchValue({
      
      fusuario:this.usuario,
      fpassword:this.password,
      fcliente:this.cliente
    });
  }
nueva(){
  this._router.navigateByUrl("new-pass");
}

  Login(e){
    this.cargando = true;
    e.preventDefault();
    console.log(e);
    let Usuario : auth= {usuario:this.usuario,password:this.password,cliente:this.cliente};
    this._servicios.autenticarUsuario(Usuario).subscribe(
        detalleData => {

          this.token = detalleData.token;
          this.cliente = detalleData.cliente;
          this.usuario = this.usuario;
          this.flag = detalleData.flag;
          this.email = detalleData.email;
          console.log(this.token)
          sessionStorage.setItem('token', this.token);
          sessionStorage.setItem('cliente', this.cliente);
          sessionStorage.setItem('usuario',this.usuario);
          sessionStorage.setItem('flag', this.flag);
          sessionStorage.setItem('email',this.email);
          if(detalleData.flag == true || sessionStorage.getItem("flag") == "true"){
            this._router.navigateByUrl("cambio-pass");
          }
        },
        error=> {

          this.cargando = false;
          if (error.status==401){
          
          swal({
            title: 'Usuario/Clave Incorrectas',
            type: 'warning',
          })
        }

        else if (error.status==0)
        {
          swal({
            title: 'Problema de conexion',
            type: 'warning',
          })

        }
        else if (error.status==403){
          swal({
            title: 'Usuario Bloqueado',
            text: 'Puede  solicitar una nueva contraseña para eliminar el bloqueo.',
            type: 'warning',
          })
        }

        },

        ()=>{this._router.navigateByUrl("R-hormigones")}
        )  
  }

 }



// WEBPACK FOOTER //
// ./src/app/views/appviews/login.component.ts